import { Injectable } from '@angular/core';
import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { setHttpLoadingStatus } from '../../@store/app.actions';
import { catchError } from 'rxjs/operators';

export const SHOW_LOADER = new HttpContextToken<boolean>(() => true);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<unknown>[] = [];

  constructor(private readonly store: Store) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);
    if (req.context.get(SHOW_LOADER)) {
      this.store.dispatch(setHttpLoadingStatus({ isLoading: true }));
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.removeRequest(req);
        }
      }),
      catchError((err) => {
        this.removeRequest(req);
        throw err;
      }),
    );
  }

  private removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }

    const action = setHttpLoadingStatus({
      isLoading: this.requests.length > 0,
    });
    this.store.dispatch(action);
  }
}
